import { EnvVars } from "./types";

declare global {
    interface Window {
        env: any
    }
}

export const env: EnvVars = { ...import.meta.env, ...window.env }